import type { IconData } from '@stacksjs/iconify-core'

export const buildingF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M9 20v-3a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v3H0V3a3 3 0 0 1 3-3h7a3 3 0 0 1 3 3v17zM4 4a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 3a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 3a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2zm0 3a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2zm4-9a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 3a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 3a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2zm0 3a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default buildingF
